export interface InputsProps {
  field: {
    name: string;
    value: string;
    position?: string;
    onChange: () => void;
    onBlur: () => void;
  };
  form: {
    touched: any;
    errors: any;
    values: string[];
  } & any;
  disabled: boolean;
  mask?: string;
  showMask?: boolean;
  customName?: string;
  label: string;
  readonly?: boolean;
  transformValue?: (value: string) => string;
}

export interface InputWrapperProps {
  touched?: boolean | undefined;
  error?: string | undefined;
  wrapperClass?: string;
  displayError?: boolean;
  showBorder?: boolean;
}

export enum BUTTON_MODS {
  CHANGE = 'CHANGE',
  OK = 'OK',
  ADD = 'ADD',
}
